import { cn } from "../../lib/cn";
import { formatPercent } from "../../lib/format";

/**
 * Tinted APY value. Greener as the rate climbs — visual cue while
 * skimming the markets table without forcing the user to read every
 * number.
 */
export function ApyBadge({ value }: { value: string }) {
	const n = Number(value);
	const tone =
		n >= 0.1
			? "text-emerald-300"
			: n >= 0.05
				? "text-emerald-400"
				: n >= 0.02
					? "text-slate-200"
					: "text-slate-400";
	return <span className={cn("font-mono", tone)}>{formatPercent(value)}</span>;
}
